import { Box, HStack, Stack, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import TagHeader from 'components/ui/TagHeader';
import { useListsByTags } from 'features/lists/hooks/useListsByTags';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export default function ListsTagView() {
  const tags = useListsByTags();

  const { setValue, watch } = useFormContext();
  const lists = watch('lists');

  const isCheckSelectAll = useCallback((tag) => {
    const ids = tag.lists.map(item => item.id);
    return ids.every(id => lists.includes(id)) 
  }, [lists]);

  const handleSelectAll = useCallback((tag, isChecked) => {
    const ids = tag.lists.map(item => item.id);
    const newValue = isChecked ? [...lists, ...ids] : lists.filter(id => !ids.includes(id));
    setValue('lists', newValue, { shouldValidate: true });
  }, [lists]);

  const handleSelectOne = useCallback((list, isChecked) => {
    const newValue = isChecked ? [...lists, list.id] : lists.filter(id => id !== list.id);
    setValue('lists', newValue, { shouldValidate: true });
  }, [lists]);

  if (!tags)
    return null;

  return (
    <Stack spacing="50px">
  { tags.map(tag => (
      <Box key={`tag-${tag.id}`}>
        <HStack justifyContent="space-between">
          <TagHeader 
            name={tag.name}
            colorScheme={tag.colorScheme}
            description={`${tag.lists.length} listas distribuídas em ${tag.companies} clientes`} 
          />
          <Switch 
            fontWeight="semibold"
            isChecked={isCheckSelectAll(tag)}
            onChange={(e) => handleSelectAll(tag, e.target.checked)}
          >
            Selecionar todas
          </Switch>
        </HStack>
        <TableContainer mt="23px">
          <Table>
            <Thead>
              <Tr>
                <Th>Nome da lista</Th>
                <Th w="350px">Empresa</Th>
                <Th w="100px"></Th>
              </Tr>
            </Thead>
            <Tbody>

            { tag.lists.map(list => (
              <Tr key={`row-${list.id}`}>
                <Td>
                  {list.name}
                </Td>
                <Td>{list.company.name}</Td>
                <Td textAlign="right">
                  <Switch
                    isChecked={lists.includes(list.id)}
                    onChange={(e) => handleSelectOne(list, e.target.checked)}
                  >
                    Selecionar
                  </Switch>
                </Td>
              </Tr>
            ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
  ))}
    </Stack>
  )
}
